import {
  Dashboard,
  PeopleAlt,
  SwitchAccount,
  FollowTheSigns,
  Event,
  Visibility,
  Assignment,
  VerifiedUser,
  WorkHistory,
  AccessTime,
  Store,
  Business,
  Input,
  Sync,
  Description,
  AccountBalance,
  Receipt,
  Assessment,
  MonetizationOn,
  Settings,
  Group,
  Schedule,
  CalendarMonth,
  Lock,
  WorkOff,
  QueryStatsSharp,
  LockReset,
  Checklist,
  FlightTakeoff,
  PriceChange,
  TrendingUp,
  Rule,
  DeviceHub,
  IntegrationInstructions,
  AccountBalanceWallet,
  Insights,
  LockOpen,
  PlaylistAddCheckCircle
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import { getUserPermissions } from "./function-helper";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";

const sideMenuList = [
  { icon: <Dashboard />, label: "HRMS Dashboard", path: "/" },
  {
    icon: <PeopleAlt />,
    label: "Employee",
    subMenu: [
      {
        label: "Employee Profile",
        path: "/view-employee",
        icon: <SwitchAccount />,
      },
      {
        label: "Core Hr",
        path: "/core-hr",
        icon: <PeopleAlt />,
      },
      {
        label: "Employee Separation",
        icon: <WorkOff />,
        path: "/separation-employee",
      },
      {
        label: "Air ticket Eligibility",
        icon: <FlightTakeoff />,
        path: "/ticket-eligible",
      },
      {
        label: "Air Fare",
        icon: <PriceChange />,
        path: "/ticket-fare",
      },
      {
        label: "User to Employee",
        icon: <WorkOff />,
        path: "/user-to-employee",
      },
      {
        label: "Employee Bulk Upload",
        path: "/employee-bulk-upload",
        icon: <SwitchAccount />,
      },
      {
        label: "Compensation Bulk Upload",
        path: "/Compensation-bulk-upload",
        icon: <SwitchAccount />,
      },
      {
        label: "Employee Workflow",
        icon: <WorkOff />,
        path: "/employee-workflow",
      },
    ],
  },
  {
    icon: <FollowTheSigns />,
    label: "Leaves",
    subMenu: [
      {
        label: "Create Leave",
        icon: <Event />,
        path: "/leave?createLeave=true",
      },
      { label: "View Leaves", path: "/leave", icon: <Visibility /> },
      {
        label: "Leave Authorized",
        icon: <VerifiedUser />,
        path: "/leave-authorized",
      },
      { label: "Leave Master", icon: <Assignment /> },
    ],
  },
  {
    icon: <AccessTime />,
    label: "Attendance",
    subMenu: [
      {
        label: "View Attendances",
        path: "/attendance-info",
        icon: <Visibility />,
      },
      {
        label: "Authorization",
        path: "/attendance-Authorization",
        icon: <VerifiedUser />,
      },
      { label: "Attendance Master", icon: <Assignment /> },
      { label: "Shift Management", icon: <WorkHistory />, path: "/shift" },
      { label: "Rotapla", icon: <Visibility /> },
      { label: "Mapping", icon: <WorkHistory /> },
    ],
  },
  {
    icon: <Checklist />,
    label: "To Do",
    path: "/To-Do",
  },
  {
    icon: <MonetizationOn />,
    label: "Payroll",
    subMenu: [
      {
        label: "Master",
        icon: <Business />,
        subMenu: [
          {
            label: "Pay Group to Employee",
            icon: <Business />,
            path: "/pay-group-to-employee",
          },
          {
            label: "Process period Master",
            icon: <Schedule />,
            path: "/process-period-master",
          },
          {
            label: "Pay Element Group Mapping",
            icon: <Group />,
            path: "/pay-element-group-mapping",
          },
          { label: "Payroll Master", icon: <Input />, path: "/pay-master" },
          {
            label: "Calendar Master",
            icon: <CalendarMonth />,
            path: "/calendar-master",
          },
          { label: "Bank Master", icon: <Business /> },
          {
            icon: <Rule />,
            label: "Rule Config",
            path: "/rule-config",
          },
          {
            icon: <TrendingUp />,
            label: "Tax Slab",
            path: "/tax-slab",
          },
        ],
      },
      // { label: "Summary Dashboard", icon: <Dashboard />, path: "/summary-dashboard" },
      { label: "Payroll Hub", icon: <DeviceHub />, path: "/payroll-hub" },
      { label: "Payroll Inputs", icon: <Input />, path: "/payroll-inputs" },
      { label: "Payroll Bulk Inputs", icon: <Input />, path: "/bulk-inputs" },
      { label: "Processing", icon: <Sync />, path: "/payroll-process" },
      {
        label: "Hold/Release Payroll Process",
        icon: <LockReset />,
        path: "/hold-release-payroll",
      },
      {
        label: "Report",
        icon: <Assessment />,
        subMenu: [
          {
            label: "Salary Statement",
            icon: <Description />,
            path: "/salary-statement",
          },
          {
            label: "Custom Report",
            icon: <Description />,
            path: "/custom-report",
          },
          { label: "Bank File", icon: <AccountBalance />, path: "/bank-file" },
          { label: "Pay Slip", icon: <Receipt />, path: "/pay-slip" },
          { label: "Payroll Tracker", icon: <Insights />, path: "/Payslip-Tracker" },
          { label: "Payroll Compliance", icon: <PlaylistAddCheckCircle />, path: "/payroll-compliance" },
          { label: "YTD Reports", icon: <Receipt />, path: "/ytd-reports" },
        ],
      },
      {
        label: "Payroll Authorization",
        icon: <Lock />,
        path: "/payroll-authorization",
      },
      {
        label: "Final Settlement",
        icon: <WorkOff />,
        path: "/final-settlement",
      },
      {
        label: "Employee cost center",
        icon: <WorkOff />,
        path: "/employee-cost-center",
      },
      {
        label: "Payroll Dashboard",
        icon: <Dashboard />,
        path: "/payroll-dashboard",
      },
    ],
  },
  {
    icon: <QueryStatsSharp />,
    label: "Query Builder",
    path: "/query-builder",
  },

  {
    icon: <Settings />,
    label: "Settings",
    subMenu: [
      { label: "Company Setup", path: "/view-companySetup", icon: <Store /> },
      {
        label: "Company Additional Parameters",
        path: "/company-AdditionalSetup",
        icon: <Store />,
      },
      { label: "Workflow", path: "/workflow", icon: <Store /> },
      {
        label: "Employee Additional section",
        path: "/employee-AdditionalSection",
        icon: <Store />,
      },
      {
        label: "Secondary Master",
        path: "/secondary",
        icon: <Store />,
      }
    ],
  },

    {
    icon: <IntegrationInstructions />,
    label: "Integrations",
    path: "/integrations",
  },
  {
    icon: <SupportAgentIcon />,
    label: "Helpdesk",
    subMenu: [
      {
        label: "Helpdesk Ticketing",
        path: "/helpDesk",
        icon: <ConfirmationNumberIcon />,
      },
       {
        label: "Helpdesk Dashboard",
        path: "/helpDesk-dashboard",
        icon: <ConfirmationNumberIcon />,
      },
    ],
  },
  {
    icon: <Assessment />,
    label: "Reports",
    subMenu: [
      {
        label: "Reports Access",
        path: "/reports-access",
        icon: <LockOpen />,
      },
      {
        label: "Report View",
        path: "/reports-view",
        icon: <Visibility />,
      },
      {
        label: "Report Master",
        path: "/reports-master",
        icon: <Assignment />,
      },
    ],
  }
  // {
  //   label: 'IAM',
  //   icon: <QuestionAnswerOutlinedIcon />,
  //   subMenu: [
  //     { label: 'User', path: '/iam/user' },
  //     { label: 'User Role Mapping', path: '/iam/user-role-mapping' },
  //     { label: 'Role', path: '/iam/role' },
  //     { label: 'Module', path: '/iam/module' },
  //     { label: 'Screen', path: '/iam/screen' },
  //     { label: 'Role Module Mapping (MASTER)', path: '/iam/role-module-mapping' },
  //   ],
  // },
];

const useMenuList = () => {
  const [userPermissions, setUserPermissions] = useState([]);

  useEffect(() => {
    const fetchPermissions = async () => {
      let permissions = (await getUserPermissions()) || [];

      // if (getRollId() === 1) {
      //   permissions = [
      //     ...permissions,
      //     { ModuleName: "IAM", ScreenName: "User" },
      //     { ModuleName: "IAM", ScreenName: "Role" },
      //     { ModuleName: "IAM", ScreenName: "Module" },
      //     { ModuleName: "IAM", ScreenName: "Screen" },
      //     { ModuleName: "IAM", ScreenName: "User Role Mapping" },
      //     { ModuleName: "IAM", ScreenName: "Role Module Mapping (MASTER)" }
      //   ];
      // }

      setUserPermissions(permissions);
    };

    fetchPermissions();
  }, []);

  const hasAccess = (module, screen) => {
    return userPermissions.some(
      (p) =>
        p.ModuleName?.toLowerCase() === module?.toLowerCase() &&
        p.ScreenName?.toLowerCase() === screen?.toLowerCase()
    );
  };

  const filterMenuByPrivileges = (menuList, parentModule = null) => {
    return menuList
      .map((item) => {
        const currentModule = parentModule || item.label;

        if (item.subMenu) {
          const filteredSubMenu = filterMenuByPrivileges(
            item.subMenu,
            currentModule
          );

          if (filteredSubMenu.length > 0) {
            return { ...item, subMenu: filteredSubMenu };
          }

          return null;
        }

        if (hasAccess(currentModule, item.label)) {
          return item;
        }

        return null;
      })
      .filter(Boolean);
  };

  const filteredMenu = filterMenuByPrivileges(sideMenuList);

  return filteredMenu;
};

export default useMenuList;
